import React, { useEffect, useMemo } from 'react'

import styles from './EventScreenNew.module.scss'
import Marquee from 'react-fast-marquee'
import images from 'assets/images'
import Button from 'components/Button'
import useResizeWidth from 'controller/useResizeWidth'
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react'

const eventList = [
  {
    value: 'irl',
    data: [
      {
        moment: 'Past',
        date: '23/8/2023',
        location: 'Bali, Indonesia',
        name: 'WAGMI⁺ Bali: ReDEFI-ning Onchain Future',
        description:
          'Join us under the starry Balinese night sky for an unforgettable journey into the realm of web3 at WAGMI⁺ Bali: ReDEFI-ning Onchain Future, a sidekick to Coinfest Week 2023, co-hosted by Coin98, Dagora, and TomoChain, in collaboration with our exclusive partners: Base, PundiX, and more to come.',
        img: images.tabIrl1,
        link: 'https://lu.ma/coin98xcoinfest',
      },
      {
        moment: 'Past',
        date: '25/11/2023',
        location: 'Hanoi, Vietnam',
        name: 'Viction Builders Meetup @Hanoi',
        description:
          "​Get ready to level up your Web3 game with a chill coffee convo! We're spilling the tea on blockchain, Web3, and diving deep into the Viction Horizon Startup Hackathon.",
        img: images.tabIrl2,
        link: 'https://lu.ma/viction-hanoi',
      },
      {
        moment: 'Past',
        date: '30/11/2023',
        location: 'Kuala Lumpur, Malaysia',
        name: 'Build on Viction Workshop @Malaysia',
        description:
          '​Immerse yourself in the dynamic realm of blockchain technology at the Build on Viction workshop. Explore Layer-1 blockchain and Web 3 wallets, fostering community building and learning. ',
        img: images.tabIrl3,
        link: 'https://lu.ma/build-on-viction',
      },
      {
        moment: 'Past',
        date: '8/12/2023',
        location: 'Jakarta, Indonesia',
        name: 'The Future of WEB3',
        description:
          '​In terms to reach the mass adoption about Blockchain Technology, BlockDevId will create an offline event aimed at increasing the number of Blockchain Developers, especially in Indonesia.',
        img: images.tabIrl4,
        link: 'https://lu.ma/Web3Future',
      },
      {
        moment: 'Past',
        date: '9/12/2023',
        location: 'Jakarta, Indonesia',
        name: 'Viction DevCraft Workshop',
        description: "Calling to all BUIDLER's, Developer's, and Student's",
        img: images.tabIrl5,
        link: 'https://luma.com/DevCraft',
      },
      {
        moment: 'Past',
        date: '26/4/2024',
        location: 'Bangkok, Thailand',
        name: "Viction Buddies' Chillout Café",
        description:
          "Join 'Viction Buddies' Chillout Café' hosted by GM Club, sponsored by Viction, for a laid-back and inviting gathering amidst the bustling atmosphere of SEA Blockchain Week.",
        img: images.tabIrl6,
        link: 'https://luma.com/viction-buddies-chillout-cafe',
      },
      {
        moment: 'Past',
        date: '2⎯5/7/2024',
        location: 'HCMC, Vietnam',
        name: 'Saigon Builder Space 2023',
        description:
          "​Get ready to level up your Web3 game with a chill coffee convo! We're spilling the tea on blockchain, Web3, and diving deep into the Viction Horizon Startup Hackathon.",
        img: images.tabIrl7,
        link: 'https://luma.com/saigonbuilderspace',
      },
      {
        moment: 'Past',
        date: '5/6/2024',
        location: 'HCMC, Vietnam',
        name: 'Saigon Builder Space 2024',
        description:
          '​Immerse yourself in the dynamic realm of blockchain technology at the Build on Viction workshop. Explore Layer-1 blockchain and Web 3 wallets, fostering community building and learning. ',
        img: images.tabIrl8,
        link: 'https://lu.ma/saigon-builder-space-2024',
      },
      {
        moment: 'Past',
        date: '6/6/2024',
        location: 'HCMC, Vietnam',
        name: 'NFT Epic Night',
        description:
          'NFT Epic Night is dedicated to bringing together NFT enthusiasts from around the world to network, socialize, and vibe in the exciting world of NFTs.',
        img: images.tabIrl9,
        link: 'https://luma.com/nbmjwuax',
      },
      {
        moment: 'Past',
        date: '7/6/2024',
        location: 'HCMC, Vietnam',
        name: 'The Limitless Future',
        description:
          'Step into the unknown and explore "The Limitless Future," an exclusive side event of GM Vietnam 2024. This gathering brings together elite builders, visionary founders, and influential C-level executives in an enigmatic setting, where the boundaries of blockchain innovation are redefined.',
        img: images.tabIrl10,
        link: 'https://luma.com/the-limitless-future',
      },
      {
        moment: 'Past',
        date: '12/11/2024',
        location: 'Bangkok, Thailand',
        name: 'BUIDL & BOND',
        description:
          'Get ready to spark new connections and ignite fresh ideas at Buidl & Bond, the warm networking night in Bangkok for Web3 enthusiasts! Co-hosted by Viction, Cleverse, Symmetry, sponsored by BTSE, dTrinity, and Zencard ,this evening is all about building meaningful relationships, sharing groundbreaking insights, and paving the way for the next wave of Web3 innovation.',
        img: images.tabIrl11,
        link: 'https://luma.com/xvnglgr3',
      },
      {
        moment: 'Past',
        date: '13/11/2024',
        location: 'Bangkok, Thailand',
        name: 'Epic Gaming Alliance Night',
        description:
          'The private dinner with native Thai game and NFT builders was held in a relaxed and chill vibe. The stunning Bangkok night view kept everyone captivated till the end.',
        img: images.tabIrl12,
        link: 'https://x.com/Eternals_World/status/1858148639849513389',
      },
      {
        moment: 'Past',
        date: '20/2/2025',
        location: 'Manila, Philippines',
        name: 'Crypto & Coins feat. Viction',
        description:
          "Get ready to dive into Viction and the next evolution of web3. Whether you're a builder, gamer, or crypto enthusiast, this is the place to network, learn, and be part of something big!...",
        img: images.tabIrl13,
        link: 'https://luma.com/37hswo6x',
      },
      {
        moment: 'Past',
        date: '10/8/2025',
        location: 'HCMC, Vietnam',
        name: 'Bull & Beer: Conviction 2025 After Dark Party',
        description:
          '​After 2 days of panels, showcases, and non-stop alpha at Conviction 2025, it’s time to unwind, connect, and toast to the future of Web3 — in true bullish style.',
        img: images.tabIrl14,
        link: 'https://luma.com/kyxkauf1',
      },
      {
        moment: 'Past',
        date: '10/8/2025',
        location: 'HCMC, Vietnam',
        name: 'Conviction Builders Night',
        description:
          '​Conviction Builders Night is a private dinner hosted by Coin98, Viction, D3, and Doma Protocol - an official side event of the Conviction.',
        img: images.tabIrl15,
        link: 'https://luma.com/ah7taqnq',
      },
    ],
  },
  {
    value: 'event',
    data: [
      {
        moment: 'Upcoming',
        date: '16/11/2025',
        location: 'HCMC, Vietnam',
        name: '731 VMs Party: Philippines 🇵🇭',
        description:
          'B​Let’s toast to the builders, believers, and dreamers who’ve made these 731 days unforgettable — and to every block we’ll build next.',
        img: images.tabEvent8,
        link: 'https://luma.com/7psnmgiw',
      },
      {
        moment: 'Upcoming',
        date: '15/11/2025',
        location: 'HCMC, Vietnam',
        name: '731 VMs Party: Vietnam 🇻🇳',
        description:
          'B​Let’s toast to the builders, believers, and dreamers who’ve made these 731 days unforgettable — and to every block we’ll build next.',
        img: images.tabEvent9,
        link: 'https://luma.com/8gratof0?tk=t361zF',
      },
      {
        moment: 'Upcoming',
        date: '15/11/2025',
        location: 'HCMC, Vietnam',
        name: '731 VMs Party: Thailand 🇹🇭',
        description:
          'B​Let’s toast to the builders, believers, and dreamers who’ve made these 731 days unforgettable — and to every block we’ll build next.',
        img: images.tabEvent10,
        link: 'https://luma.com/22rx9g1g',
      },
      {
        moment: 'Upcoming',
        date: '14/11/2025',
        location: 'HCMC, Vietnam',
        name: '731 VMs Party: Indonesia 🇮🇩',
        description:
          'B​Let’s toast to the builders, believers, and dreamers who’ve made these 731 days unforgettable — and to every block we’ll build next.',
        img: images.tabEvent11,
        link: 'https://luma.com/9mksvkc8',
      },
      {
        moment: 'Past',
        date: '9/11⎯2/12/2023',
        location: 'HCMC, Vietnam',
        name: 'Build on Viction Workshop @HCMC',
        description:
          'BUILD ON VICTION – Platform for Potential: a Web3 programming training series and application-building competition on the Viction blockchain. The program is open to all tech enthusiasts, with NO experience required',
        img: images.tabEvent1,
        link: 'https://luma.com/buildonvictionworkshop',
      },
      {
        moment: 'Past',
        date: '9/11/2023',
        location: 'Online',
        name: 'Build on Viction Online Workshop',
        description:
          'BUILD ON VICTION – Platform for Potential: a Web3 programming training series and application-building competition on the Viction blockchain. The program is open to all tech enthusiasts, with NO experience required',
        img: images.tabEvent2,
        link: 'https://lu.ma/buildonvictionworkshop',
      },
      {
        moment: 'Past',
        date: '30/11/2023',
        location: 'Online',
        name: 'Decoding Viction: Exploring Vision, and Innovations in Web3',
        description:
          'Emphasizing collaboration, efficiency, and innovative on-chain project development, Viction provides developers with a realistic and cost-effective path.',
        img: images.tabEvent3,
        link: 'https://medium.com/tintinland/victions-new-chapter-technological-transformation-and-ambitious-vision-of-vietnam-s-public-chain-5986486b87b9',
      },
      {
        moment: 'Past',
        date: '4/12/2023',
        location: 'Online',
        name: 'Viction: From Consensus to Development｜Workshop',
        description:
          'TinTin Meeting is an online live broadcast column opened by TinTinLand. It focuses on the field of blockchain technology and invites industry technical experts and participants to discuss the practical experience and construction results of blockchain technology. It aims to provide developers with blockchain development experience. New ideas, new plans.',
        img: images.tabEvent4,
        link: 'https://www.youtube.com/watch?v=cjGsCdZVePY',
      },
      {
        moment: 'Past',
        date: '7/12/2023',
        location: 'Online',
        name: 'A Guide to Initiate a Product Launch',
        description:
          'Viction hosted a captivating AMA session with Matrixport, Alt Layer, and BTSE to discuss how to build web3 products from scratch.',
        img: images.tabEvent5,
        link: '',
      },
      {
        moment: 'Past',
        date: 'May 2024',
        location: 'Multiple countries',
        name: 'Viction Pizza Day',
        description: 'Happy Viction Pizza Day!',
        img: images.tabEvent6,
        link: 'https://blog.viction.xyz/a-guide-to-initiate-a-product-launch-ama-recap/',
      },
      {
        moment: 'Past',
        date: '7/8/2025',
        location: 'HCMC, Vietnam',
        name: "Dagora x Viction Holders' Coffee Space",
        description:
          "​Get ready to level up your Web3 game with a chill coffee convo! We're spilling the tea on blockchain, Web3, and diving deep into the Viction Horizon Startup Hackathon.",
        img: images.tabEvent7,
        link: 'https://lu.ma/gbanwuzz',
      },
    ],
  },
]

const arrDropdowns = [
  {
    name: 'All Status',
    value: 'all',
  },
  {
    name: 'On-going',
    value: 'on-going',
  },
  {
    name: 'Up-coming',
    value: 'up-coming',
  },
  {
    name: 'Past',
    value: 'past',
  },
]

function EventScreenNew() {
  const { positionY } = useResizeWidth()
  const imgWrapperBottomRef = React.useRef(null)
  const eventTabRef = React.useRef(null)
  const inputDropdownRef = React.useRef(null)

  // const [isChangeText, setIsChangeText] = React.useState(false)
  const [tabChoose, setTabChoose] = React.useState('irl')
  const [showMoreTab, setShowMoreTab] = React.useState(false)
  const [searchValue, setSearchValue] = React.useState('')
  const [isShowDropdown, setIsShowDropdown] = React.useState(false)
  const [dropdownChoose, setDropdownChoose] = React.useState(arrDropdowns[0])

  const isChangeText = positionY - 400 >= imgWrapperBottomRef.current?.offsetTop
  const dataTab = eventList.find((item) => item.value === tabChoose).data

  const dataFinal = useMemo(() => {
    let dataTemp

    dataTemp = dataTab.filter((item) =>
      item.name.toLowerCase().includes(searchValue.toLowerCase())
    )

    if (dropdownChoose.value !== 'all') {
      dataTemp = dataTemp.filter(
        (item) =>
          item.moment.toLowerCase() ===
          (dropdownChoose.value === 'past'
            ? 'past'
            : dropdownChoose.value === 'on-going'
            ? 'on-going'
            : 'up-coming')
      )
    }

    return showMoreTab ? dataTemp : dataTemp.slice(0, 5)
  }, [dataTab, searchValue, showMoreTab, tabChoose, dropdownChoose])

  const isActionSearchStand = positionY + 300 >= eventTabRef.current?.offsetTop

  useEffect(() => {
    setShowMoreTab(false)
    setSearchValue('')
  }, [tabChoose])

  return (
    <div className={styles.eventScreenNew}>
      <div className='event-screen'>
        <div className='event-banner'>
          <div className='event-banner-container'>
            <h1 className='event-banner-title'>Join What Matters</h1>
            <div className='event-banner-description'>
              Let's meet your people IRL or join the virtual fun. <br /> Maybe
              you’ll take home some swag, earn wallet rewards, and connect with
              cool peers from around the world.
            </div>
          </div>

          <div className='event-banner-slide'>
            <img
              src={images.curveWhite}
              alt=''
              className='img-curve img-curve--down'
            />
            <img
              src={images.curveWhite}
              alt=''
              className='img-curve img-curve--up'
            />

            <Marquee>
              <div className='banner-img'>
                <img
                  src={images.communityBanner1}
                  className='item-banner'
                  alt=''
                />
              </div>
              <div className='banner-img'>
                <img
                  src={images.communityBanner2}
                  className='item-banner'
                  alt=''
                />
              </div>
              <div className='banner-img'>
                <img
                  src={images.communityBanner3}
                  className='item-banner'
                  alt=''
                />
              </div>
              <div className='banner-img'>
                <img
                  src={images.communityBanner4}
                  className='item-banner'
                  alt=''
                />
              </div>
              <div className='banner-img'>
                <img
                  src={images.communityBanner5}
                  className='item-banner'
                  alt=''
                />
              </div>
              <div className='banner-img'>
                <img
                  src={images.communityBanner6}
                  className='item-banner'
                  alt=''
                />
              </div>
              <div className='banner-img'>
                <img
                  src={images.communityBanner7}
                  className='item-banner'
                  alt=''
                />
              </div>
              <div className='banner-img'>
                <img
                  src={images.communityBanner8}
                  className='item-banner'
                  alt=''
                />
              </div>
              <div className='banner-img'>
                <img
                  src={images.communityBanner9}
                  className='item-banner'
                  alt=''
                />
              </div>
              <div className='banner-img'>
                <img
                  src={images.communityBanner10}
                  className='item-banner'
                  alt=''
                />
              </div>
            </Marquee>
          </div>
        </div>

        <div className='event-call'>
          <div className='event-call-content'>
            <div className='event-call-text'>
              <div
                className={`text-title ${isChangeText && 'text-title--hide'}`}>
                Viction Monthly <br /> Community Call
              </div>

              <div
                className={`text-description ${
                  isChangeText && 'text-description--show'
                }`}>
                Every month, we go live on X, Discord, and Telegram to recap
                what’s happened, what’s coming next, and even spill some alpha.
              </div>
            </div>

            <div className='event-action'>
              <a href='https://x.com/Frontier_DAO' target='_blank' rel='noreferrer'>
                <Button>
                  Stay in The Loop{' '}
                  <span className='icon-web_arrow_up_right arrow-icon'></span>
                </Button>
              </a>
            </div>
          </div>

          <div className='img-wrapper img-wrapper--top'>
            <div className='img-item img-item--small'>
              <img src={images.eventCall1} alt='' className='img-call' />
            </div>

            <div className='img-item img-item--square'>
              <img src={images.eventCall2} alt='' className='img-call' />
            </div>
          </div>

          <div
            className='img-wrapper img-wrapper--bottom'
            ref={imgWrapperBottomRef}>
            <div className='img-item img-item--square'>
              <img src={images.eventCall3} alt='' className='img-call' />
            </div>

            <div className='img-item img-item--small'>
              <img src={images.eventCall4} alt='' className='img-call' />
            </div>
          </div>
        </div>

        <div className='event-content'>
          <div className='event-content-container'>
            <div className='event-content-tabs'>
              <div
                className={`content-tabs-item ${
                  tabChoose === 'irl' ? 'content-tabs-item--active' : ''
                }`}
                onClick={() => setTabChoose('irl')}>
                Viction IRL
              </div>
              <div
                className={`content-tabs-item ${
                  tabChoose === 'event' ? 'content-tabs-item--active' : ''
                }`}
                onClick={() => setTabChoose('event')}>
                Community Event
              </div>
            </div>

            <div className='event-content-list' ref={eventTabRef}>
              {dataFinal.map((event, index) => {
                return (
                  <a
                    key={index}
                    href={event.link}
                    target='_blank'
                    rel='noreferrer'>
                    <div className='item-list-event'>
                      <div className='item-list-event--sub-head'>
                        <div className='sub-head-info'>
                          {event.moment} <div className='dot'></div>{' '}
                          {event.date} <div className='dot'></div>{' '}
                          {event.location}
                        </div>

                        <div className='sub-head-more'>More Details</div>
                      </div>

                      <div className='item-list-event--detail'>
                        <div className='detail-name'>{event.name}</div>

                        <div className='detail-description'>
                          {event.description}
                        </div>

                        <img src={event.img} alt='' className='item-banner' />
                      </div>
                    </div>
                  </a>
                )
              })}
            </div>

            <div className={`show-more ${showMoreTab && 'show-more--hidden'}`}>
              <div
                className='text-show text-hover-underline'
                onClick={() => setShowMoreTab(true)}>
                Show More
              </div>
            </div>

            <div
              className={`action-search ${
                isActionSearchStand && 'action-search--stand'
              }`}>
              <div className='input-box'>
                <input
                  type='text'
                  placeholder='Search your projects'
                  className='input-search'
                  value={searchValue}
                  onChange={(e) => setSearchValue(e.target.value)}
                />
              </div>

              <div className='dropdown-box'>
                <div
                  className='dropdown'
                  onClick={() => setIsShowDropdown(!isShowDropdown)}>
                  <div className='dropdown-label'>
                    {isShowDropdown ? (
                      <>
                        <input
                          type='text'
                          placeholder={dropdownChoose.name}
                          className='input-dropdown'
                          ref={inputDropdownRef}
                        />{' '}
                        <ChevronDownIcon size={16} />
                      </>
                    ) : (
                      <>
                        {dropdownChoose.name} <ChevronUpIcon size={16} />
                      </>
                    )}
                  </div>

                  <div
                    className={`dropdown-list ${
                      isShowDropdown && 'dropdown-list--show'
                    }`}>
                    <div className='dropdown-list-content'>
                      {arrDropdowns.map((item, index) => {
                        return (
                          <div
                            className='item-dropdown'
                            key={index}
                            onClick={() => setDropdownChoose(item)}>
                            {item.name}
                          </div>
                        )
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default EventScreenNew
